(ns frontend.view.settings2.web-form.event
  (:require [frontend.state.current-session :as session]
            [frontend.view.settings2.web-form.sub :as sub]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::set-selected-webentry-id
 (fn [{db :db} [_ id]]
   {:db (assoc db ::sub/selected-webentry-id id)}))

(rf/reg-event-fx
 ::set-first-webentry
 (fn [{db :db} [_ ignore-ids]]
   (let [first-webentry-id (->> @session/all-webentries
                                (remove :common/disabled?)
                                (remove (fn [e]
                                          (some #{(:db/id e)} ignore-ids)))
                                (sort-by :common/created-on)
                                first
                                :db/id)]
     {:db (assoc db ::sub/selected-webentry-id first-webentry-id)})))
